import AliasEqualsModel from "../../../attributes/filters/AliasEqualsModel.js";
const attrName = 'assetLocators.calculatedAlerts';
export default AliasEqualsModel.create(attrName);